import createStyles from '@material-ui/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import { styled } from '@mui/material';

export const marginStyles = makeStyles((theme: Theme) => {
    const spacing2 = theme.spacing(2);
    const spacing3 = theme.spacing(3);
    const spacing5 = theme.spacing(5);
    return createStyles({
        marginY2: {
            marginTop: spacing2,
            marginBottom: spacing2,
        },
        marginY3: {
            marginTop: spacing3,
            marginBottom: spacing3,
        },
        paddingY3: {
            paddingTop: spacing3,
            paddingBottom: spacing3,
        },
        marginY5: {
            marginTop: spacing5,
            marginBottom: spacing5,
        },
        paddingY5: {
            paddingTop: spacing5,
            paddingBottom: spacing5,
        },
    });
});

export const scrollBarStyles = {
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
    },
};

export const grayBackgroundColor = '#F6F6F6';

export const errorTextStyles = makeStyles((theme: Theme) =>
    createStyles({
        errorText: {
            color: '#DF5E61',
            borderRadius: 4,
            display: 'inline-block',
            marginTop: theme.spacing(3),
            backgroundColor: 'rgba(213, 41, 44, 0.1)',
            padding: theme.spacing(2, 4),
            width: '100%',
        },
    }),
);

export const textFieldWidth = 512;
export const textFieldBorder = '2px solid #CACACA';

export const StyledTextField = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isError',
})<{ isError?: boolean }>(({ theme, isError }) => ({
    position: 'relative',
    textAlign: 'center',
    margin: 'auto',
    width: textFieldWidth,
    '& input': {
        textAlign: 'center',
        width: '100%',
        border: 0,
        padding: theme.spacing(2),
        fontSize: '22px',
        caretColor: theme.palette.primary.main,
        appearance: 'none',
        backgroundColor: grayBackgroundColor,
        borderBottom: isError ? '2px solid red' : textFieldBorder,
        '-webkit-appearance': 'none',
        '&::placeholder': {
            color: '#aaaaaa',
        },
        '&:focus, &:active': {
            borderColor: theme.palette.primary.main,
        },
    },
    '& input:focus': {
        outline: 'none',
    },
    [`@media (max-width:${textFieldWidth + pageBothSidesPadding}px)`]: {
        width: '100%',
    },
}));
export const textFieldStyles = makeStyles((theme: Theme) => ({
    textField: {
        position: 'relative',
        textAlign: 'center',
        margin: 'auto',
        width: textFieldWidth,
        '& input': {
            textAlign: 'center',
            width: '100%',
            border: 0,
            padding: theme.spacing(3),
            fontSize: theme.typography.h3.fontSize,
            caretColor: theme.palette.primary.main,
            appearance: 'none',
            backgroundColor: grayBackgroundColor,
            borderBottom: (isError: boolean) =>
                isError ? '2px solid red' : textFieldBorder,
            '-webkit-appearance': 'none',
            '&::placeholder': {
                color: '#aaaaaa',
            },
            '&:focus, &:active': {
                borderColor: theme.palette.primary.main,
            },
        },
        '& input:focus': {
            outline: 'none',
        },
        [`@media (max-width:${textFieldWidth + pageBothSidesPadding}px)`]: {
            width: '100%',
        },
    },
}));

export const useButtonStyles = makeStyles((theme: Theme) =>
    createStyles({
        submit: {
            cursor: 'pointer',
            color: '#fff',
            minWidth: '140px !important',
            minHeight: 48,
            borderRadius: 6,
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            marginTop: theme.spacing(3),
            '& svg': {
                marginLeft: theme.spacing(1),
                marginRight: '0 !important',
                width: '18px',
            },
        },
        mainButton: {
            margin: theme.spacing(5, 0),
            minWidth: 220,
        },
        wrapper: {
            position: 'relative',
            display: 'inline-block',
        },
        buttonProgress: {
            color: theme.palette.primary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
    }),
);

export const roundButtonStyles = makeStyles(() =>
    createStyles({
        roundButton: {
            borderRadius: '40px !important',
            padding: '7px 20px !important',
        },
    }),
);

const boxStyles = (spacing: number) => ({
    width: 688,
    margin: 'auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    marginTop: spacing,
    marginBottom: spacing,
    paddingTop: spacing,
    paddingBottom: spacing,
    '@media (max-width:688px)': {
        width: '100%',
        '& .grid-right': {
            marginTop: spacing,
        },
    },
});

export const finalStepStyles = makeStyles((theme: Theme) => {
    const spacing3 = theme.spacing(3);
    const spacing4 = theme.spacing(4);
    const spacing5 = theme.spacing(5);
    const spacing7 = theme.spacing(7);
    const spacingY1 = theme.spacing(1, 0);
    return createStyles({
        finalStep: {
            textAlign: 'center',
            maxWidth: '700px',
            margin: `${spacing3}px auto`,
        },
        checkbox: {
            textAlign: 'left',
            marginBottom: '20px',
            '& .MuiFormControlLabel-label': {
                paddingTop: '7px',
                paddingLeft: '10px',
            },
            '& span': {
                fontSize: 14,
            },
        },
        errorStyles: {
            paddingTop: spacing4,
            paddingBottom: spacing4,
        },
        passwordStep: {
            ...boxStyles(theme.spacing(6)),
            paddingLeft: spacing7,
            paddingRight: spacing7,
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            '& .password-field': {
                marginTop: theme.spacing(2),
            },
            '& label': {
                marginRight: 0,
            },
            '& .reCaptcha': {
                paddingLeft: 16,
                marginBottom: 25,
            },
        },
        reviewSignup: {
            ...boxStyles(spacing5),
            marginBottom: 0,
            textAlign: 'left',
            '& .grey-border-right': {
                borderRight: '2px solid #E7E7E7',
            },
            '& .grid-wrapper': {
                paddingLeft: spacing5,
                paddingRight: spacing5,
                overflowWrap: 'anywhere',
            },
            '& .middle-grid': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                '& div': {
                    margin: spacingY1,
                },
            },
            '& .grid': {
                marginTop: spacing4,
                '& div': {
                    margin: spacingY1,
                },
            },
        },
        topGridStyles: {
            display: 'flex',
            justifyContent: 'space-between',
            '& .left': {
                flex: '1 1',
            },
        },
    });
});

const pageSidePadding = 16;
// padding on each side of the page
const pageBothSidesPadding = pageSidePadding * 2;

// export const signupStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         middleContent: {
//             textAlign: 'center',
//             maxWidth: ({ maxWidth }: { maxWidth: number }) =>
//                 maxWidth + pageBothSidesPadding,
//             width: '100%',
//             margin: 'auto',
//             paddingLeft: pageSidePadding,
//             paddingRight: pageSidePadding,
//             '& .slide-in-animation': {
//                 animation: `$slideIn 300ms ${theme.transitions.easing.easeInOut}`,
//             },
//         },
//         '@keyframes slideIn': {
//             '0%': {
//                 opacity: 0,
//                 transform: 'translateY(-100%)',
//             },
//             '100%': {
//                 opacity: 1,
//                 transform: 'translateY(0)',
//             },
//         },
//     }),
// );

export const StyledMiddleContent = styled('div', {
    shouldForwardProp: (prop) => prop !== 'maxWidth',
})<{ maxWidth: number }>(({ theme, maxWidth }) => ({
    textAlign: 'center',
    maxWidth: `${maxWidth + pageBothSidesPadding}px`,
    width: '100%',
    margin: 'auto',
    paddingLeft: pageSidePadding,
    paddingRight: pageSidePadding,
    '& .slide-in-animation': {
        animation: `$slideIn 300ms ${theme.transitions.easing.easeInOut}`,
    },

    '@keyframes slideIn': {
        '0%': {
            opacity: 0,
            transform: 'translateY(-100%)',
        },
        '100%': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
}));

export const signupContentStyles = makeStyles((theme: Theme) =>
    createStyles({
        logo: {
            height: '60px',
            width: 'auto',
            margin: theme.spacing(4, 5, 6, 5),
        },
        content: {
            flexDirection: 'column',
            minHeight: '100vh',
            '& .heart': {
                display: 'block',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: theme.spacing(7),
                marginBottom: theme.spacing(7),
            },
            '& .top-grid': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexGrow: 1,
            },
        },
    }),
);

export const progressBarWidth = 190;
export const progressStyles = makeStyles((theme: Theme) => {
    const spacing2 = theme.spacing(2);
    return createStyles({
        progress: {
            textAlign: 'center',
            '& .bar': {
                position: 'relative',
                margin: 'auto',
                width: `${progressBarWidth}px`,
                height: '4px',
            },
            '& .top': {
                position: 'absolute',
                backgroundColor: theme.palette.primary.main,
                height: '100%',
                zIndex: 1,
            },
            '& .bottom': {
                position: 'absolute',
                backgroundColor: '#D9D9D9',
                width: '100%',
                height: '100%',
            },
        },
        stepBar: {
            padding: '0 !important',
            '& .icons': {
                display: 'inline-block',
                margin: spacing2,
                paddingLeft: spacing2,
                borderLeft: '1px solid #D8D8D8',
            },
            '& .label': {
                display: 'inline-block',
                marginRight: spacing2,
                marginLeft: theme.spacing(3),
            },
        },
    });
});

export const errorMessageStyles = makeStyles(() =>
    createStyles({
        errorMessage: {
            color: 'inherit',
            fontWeight: 'bold',
        },
    }),
);
